export let seasonId = '';
export let divisionIdM = '';
export let divisionIdG = '';

if (process.env.NODE_ENV == 'production') {
  if (process.env.VUE_APP_REALEASE === 'test') {
    seasonId = '1071';
    divisionIdM = '50';
    divisionIdG = '60';
  } else {
    seasonId = '1102';
    divisionIdM = '50';
    divisionIdG = '60';
  }
} else {
  seasonId = '1071';
  divisionIdM = '50';
  divisionIdG = '60';
}
